import { render, staticRenderFns } from "./TableColumnSettings.vue?vue&type=template&id=63318186"
import script from "./TableColumnSettings.vue?vue&type=script&lang=js"
export * from "./TableColumnSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports